import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private apiService: ApiService) {}

  async sendMail(data: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.post<any>('/messages', data).subscribe({
        next: (res) => {
          resolve(res);
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  contactMutuelle(data: {
    subject: string;
    message: string;
    files?: { name: string; data: string }[];
  }): Promise<{ success: boolean }> {
    const mutuelle = environment.mutuelleCode;
    return new Promise(async (resolve, reject) => {
      this.apiService
        .post<{ success: boolean }>(
          '/mutuelles/' + mutuelle + '/contact',
          data,
          true
        )
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }
}
